"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseLanguageTag = parseLanguageTag;
exports.convertLanguageTag = convertLanguageTag;
exports.normalizeLanguageTag = normalizeLanguageTag;
exports.getLanguageTags = getLanguageTags;
exports.getLanguageTagById = getLanguageTagById;
exports.getLanguageTagByCode = getLanguageTagByCode;

var _languageTags = _interopRequireDefault(require("./data/language-tags.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _wrapRegExp() {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  _inherits(BabelRegExp, RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;

        if (typeof args[args.length - 1] !== "object") {
          args = [].slice.call(args);
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var tagRegEx = /*#__PURE__*/_wrapRegExp(/^([a-z]{2,3})(_([A-Z]{1}[a-z]{3}))?(_([A-Z]{2}|[0-9]{3}))?(_([0-9A-Za-z]{5,8}|[0-9][0-9A-Za-z]{3}))?$/, {
  primary: 1,
  script: 3,
  region: 5,
  variant: 7
});

var LANGUAGE_TAGS = _languageTags.default;
/**
 * Break a sting Language Tag into it's components based on IETF BCP 47
 *
 * @param tag - (_casing sensitive_) the language tag to be parsed, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */

function parseLanguageTag(tag) {
  var matches = tagRegEx.exec(tag);
  return matches === null || matches === void 0 ? void 0 : matches.groups;
}
/**
 * Replace the delimiter of the string Language Tag, by default to the ISO standard `-`
 *
 * @param tag - the language tag to be converted, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */


function convertLanguageTag(tag) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return tag.replace(/[_-]/gi, delimiter);
}
/**
 * Convert the string Language Tag to all lowercase hyphenated representation
 *
 * @example `zh_Hant_TW` becomes `zh-hant-tw`
 *
 * @param tag - the language tag to be normalized, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */


function normalizeLanguageTag(tag) {
  return convertLanguageTag(tag).toLowerCase();
}
/** Get array of all possible `LanguageTagDefinition` */


function getLanguageTags() {
  return LANGUAGE_TAGS;
}
/**
 * Get a specific `LanguageTagDefinition` by its id
 *
 * @param id example `"1"` for _English_ or `"361"` for _Croatian (Bosnia and Herzegovina)_
 * @returns
 */


function getLanguageTagById(id) {
  return LANGUAGE_TAGS.find(function (def) {
    return def.id === id;
  });
}
/**
 * Convert the string Language Tag to all lowercase hyphenated representation
 *
 * @example `zh_Hant_TW` becomes `zh-hant-tw`
 *
 * @param code - the code (aka. language tag) to be searched for, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */


function getLanguageTagByCode(code) {
  var nt = normalizeLanguageTag;
  return LANGUAGE_TAGS.find(function (def) {
    return nt(def.code) === nt(code);
  });
}